import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../../../../aem-core-components';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import { VARIABLE_CONFIG } from '../../../../../constants/analyticsConstants/Variables';
import { usePageType } from '../../../../../hooks/usePageType';
import ChevronDown from '../../../../../resources/images/chevron-down-green.svg';
import Plus from '../../../../../resources/images/plus16.svg';
import { logError } from '../../../../global/utils/logger';
import { ENV_CONFIG } from '../../../../../constants/envConfig';
import { categoryFacet } from '../../../controllers/searchresultscontroller';
import './categoryfacet.scss';

export default function CategoryFacet({ catFacetState, setCatFacetState }) {
    const intl = useIntl();
    const [isListVisible, setIsListVisible] = useState(ENV_CONFIG.META_FACETS_STATE);
    const pageType = usePageType();
    const { sendEventsForClick } = useAnalyticsContext();
    useEffect(() => {
        categoryFacet && categoryFacet.subscribe(updateState);
    }, []);
    const analyticsEvent = value => {
        try {
            sendEventsForClick(
                VARIABLE_CONFIG.EVENT.UAEVENT,
                VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                `filter ${pageType}`,
                VARIABLE_CONFIG.EVENT_ACTION.SELECT,
                `category::${value?.value.toLowerCase()} (${value?.numberOfResults ? value?.numberOfResults : ''})`
            );
        } catch (error) {
            logError(error, false, 'analyticsEvent');
        }
    };
    const updateState = () => {
        setCatFacetState(categoryFacet?.state);
    };

    const toggleSelect = value => {
        categoryFacet.toggleSelect(value);
    };

    const showMore = () => {
        categoryFacet.showMoreValues();
    };

    //sends left position offset value to getValues <Box> depending on state
    const valuesAlign = () => {
        return catFacetState?.hasActiveValues ? 'facet__child' : 'facet__parent';
    };
    const handleOnParentClick = (isLast, parent) => {
        !isLast && toggleSelect(parent);
        analyticsEvent(parent);
    };

    const getParents = () => {
        const parents = catFacetState?.parents;
        return parents?.map((parent, i) => {
            const isLast = i === parents?.length - 1;
            return (
                <button
                    key={parent.value}
                    onClick={() => handleOnParentClick(isLast, parent)}
                    className="facet__button">
                    {parent.value}
                </button>
            );
        });
    };

    const handleOnClick = value => {
        toggleSelect(value);
        analyticsEvent(value);
    };
    const getValues = () => {
        const align = valuesAlign();

        return catFacetState?.values.map(value => (
            <button key={value.value} onClick={() => handleOnClick(value)} className={`facet__button ${align}`}>
                {value.value} ({value.numberOfResults})
            </button>
        ));
    };

    const getShowMore = () => {
        return (
            <Button type="button" onClick={() => showMore()} className="filter__item-button" data-testid="category-facet-show-more">
                {'Show more'}
                <Plus />
            </Button>
        );
    };

    return (
        <div className="facet facet--wrap">
            <div className={`filter__item ${isListVisible ? 'filter__item--open' : ''}`}>
                <div className="filter__title" onClick={() => setIsListVisible(!isListVisible)}>
                    {intl.formatMessage({ id: 'CategoryFacet-title' })}
                    <button
                        aria-expanded={isListVisible}
                        className={`filter__title-expend ${isListVisible && 'expandedList'}`}
                        aria-label={
                            isListVisible
                                ? `${intl.formatMessage({ id: 'CategoryFacet-title' })} ${intl.formatMessage({
                                      id: 'filter:expanded-filter'
                                  })} `
                                : `${intl.formatMessage({ id: 'CategoryFacet-title' })} ${intl.formatMessage({
                                      id: 'filter:collapsed-filter'
                                  })} `
                        }>
                        <ChevronDown />
                    </button>
                </div>
                <div className={`filter__item-body ${isListVisible ? 'filter__item-body--open' : ''}`}>
                    {getParents()}
                    {getValues()}
                    {catFacetState?.canShowMoreValues && getShowMore()}
                </div>
            </div>
        </div>
    );
}
